'use client';

import CartIcon from 'components/_other/icons/CartIcon';
import useCart from 'grandus-lib/hooks/useCart';
import { MiniCart } from '@/modules/cart/components/minicart/MiniCart';

const ItemCart = ({}) => {
  const { cart } = useCart();

  const handleCartClick = e => {
    e.preventDefault();
    dispatchMiniCartOpenEvent();
  };

  const dispatchMiniCartOpenEvent = () => {
    const event = new CustomEvent('miniCartOpen');
    document.dispatchEvent(event);
  };

  return (
    <>
      <a
        className={`flex items-center justify-center ${cart?.count > 0 ? 'border border-black dark:border-beige px-2 py-1 rounded-[2px]' : ''}`}
        href="/kosik"
        onClick={handleCartClick}
      >
        <div className="relative mr-[15px]">
          <CartIcon className={'text-black dark:text-beige'} />
          {cart?.pieceCount > 0 && (
            <div className=" flex items-center justify-center absolute w-[13px] h-[13px] text-[10px] -top-0.5 -end-2 rounded-full bg-primary bg-primary dark:bg-beige text-white dark:text-black">
                {cart?.pieceCount ?? 0}
            </div>
          )}
        </div>
        {cart?.pieceCount > 0 && <span className="font-normal text-black dark:text-white text-nowrap">{cart?.sumData?.priceFormatted}</span>}
      </a>
      <MiniCart />
    </>
  );
};

export default ItemCart;
